package br.com.texeratx.boardgametimeapp.ui.screens.expansions.create

import br.com.texeratx.boardgametimeapp.domain.usecases.games.GameOption

data class CreateExpansionState(
    val name: String = "",
    val bggUrl: String = "",

    // imagem (resultado do upload; não editável na UI)
    val imageUrl: String? = null,

    // imagem local (preview + upload)
    val selectedImageName: String? = null,
    val localImageBytes: ByteArray? = null,
    val localImageMimeType: String? = null,
    val isUploadingImage: Boolean = false,

    val games: List<GameOption> = emptyList(),
    val selectedGameId: Long? = null,

    val isLoadingGames: Boolean = false,
    val isSaving: Boolean = false,
    val errorMessage: String? = null,
    val uiMessage: String? = null
)
